module.exports = __webpack_public_path__ + "static/media/KAEDCO.6c01da82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/KAEDCO.png
// module id = 375
// module chunks = 25